import React from 'react';
import { PageGiveViewModel } from './page-give-view-model';
import { Text } from '../../components/text';
import * as style from './page-give.less';
import { Link } from '../../primitives/link/link';
import { GivingType } from './page-give';
import { InjectableWebGivingProps, injectWebGivingProps, raiseAction } from '../../utils/injectable-props';
import { WebGivingUserAction } from '../../webgiving-user-actions';

const ENGIVEN_TERMS_URL = 'https://www.engiven.com/terms-of-service';
const LEARN_MORE_CRYPTO_URL = 'https://help.pushpay.com/s/knowledge/How-to-Give-using-Cryptocurrency';
const LEARN_MORE_STOCK_URL = 'https://help.pushpay.com/s/knowledge/How-to-Give-Using-Stock'

@injectWebGivingProps
export class PageGiveOther extends React.Component<{
    givingType: GivingType;
    vm: PageGiveViewModel;
} & InjectableWebGivingProps> {

    render() {
        const {
            givingType,
            vm: { paymentLabel: { NounLowerCase, VerbLowerCase, NounPluralLowerCase, VerbPresentTenseLowerCase }, },
        } = this.props;

        this.logEngagement(givingType);

        const currencyType = givingType == GivingType.Cryptocurrency ? 'cryptocurrency' : 'stock'
        return (
            <div>
                <div className={style.headerContent}>
                    <img
                        data-pp-at-target="Engiven-logo"
                        className={style.logo}
                        src="../../../../Content/WebGiving/assets/images/engiven-logo.png"
                        alt="engiven logo image"
                    />
                </div>
                <div className={style.content}>
                    <p>
                        <Text>
                            {`We have partnered with Engiven to make it easy to ${VerbLowerCase} with ${currencyType}.`}</Text>
                    </p>
                    <p>
                        <Text>
                            {`To make your ${NounLowerCase}, click the button below to be redirected to Engiven's website, enter your ${NounLowerCase} amount and fill out the form.`}
                        </Text>
                    </p>
                    <p>
                        <Text>{`All ${NounPluralLowerCase} will be converted to USD.`}</Text>
                    </p>
                    <p>
                        <Text>Engiven is a trusted partner of Pushpay. </Text>
                        <Link
                            openInNewTab={true}
                            branded={true}
                            acceptanceTestTargetId="Crypto learn more"
                            href={givingType == GivingType.Cryptocurrency ? LEARN_MORE_CRYPTO_URL : LEARN_MORE_STOCK_URL}
                        >
                            <Text>Click here </Text>
                        </Link>
                        <Text
                        >{`to learn more about ${VerbPresentTenseLowerCase} in ${currencyType}.`}</Text>
                    </p>
                    <p>
                        <Link
                            openInNewTab={true}
                            branded={true}
                            acceptanceTestTargetId="Engiven terms and conditions"
                            href={ENGIVEN_TERMS_URL}
                        >
                            <Text>Engiven terms and conditions apply</Text>
                        </Link>
                    </p>
                </div>
            </div>
        )
    }

    private logEngagement = (givingType: GivingType) =>
    {
        switch(givingType) {
            case GivingType.Cryptocurrency:
                raiseAction(new WebGivingUserAction.LogCryptoEngagement, this.props);
                break;
            case GivingType.Stock:
                raiseAction(new WebGivingUserAction.LogStockEngagement, this.props);
                break;
        }
    }
}